import { render, staticRenderFns } from "./ReportChargeRatesPage.vue?vue&type=template&id=6522ac8c&scoped=true&"
import script from "./ReportChargeRatesPage.vue?vue&type=script&lang=js&"
export * from "./ReportChargeRatesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6522ac8c",
  null
  
)

export default component.exports